export default __webpack_public_path__ + "assets/images/9c01dbaa70f34f4c0601aae41dd16304.png";